import axios from 'axios';
import { getAdapter } from '@zyf2e/adapt';
import { Toast } from '@zyf2e/capui-mobile';

const adapt = getAdapter();
let loading;

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 3 * 60 * 1000,
  withCredentials: true
});

HTTP.interceptors.request.use(
  config => {
    loading = Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
      position: 'top'
    });
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

HTTP.interceptors.response.use(
  response => {
    loading.clear();
    const { ok, result, error } = response.data;
    if (ok) {
      return 'result' in response.data ? result : response.data;
    }
    if (error) {
      Toast({
        message: error.msg,
        position: 'top'
      });
    }
    return Promise.reject(error);
  },
  error => {
    if (error.response.status === 401) {
      Toast({
        message: '授权失败，请重新登陆',
        position: 'top'
      });
      adapt.reLogin();
    } else {
      Toast({
        message: '请求失败，请稍后再试',
        position: 'top'
      });
    }

    try {
      if (error.response.status) {
        return Promise.reject(error.response.status);
      }
      return Promise.reject(error);
    } catch (err) {
      return Promise.reject({
        ...error,
        message: err.message
      });
    }
  }
);

const requestFactory = () => {
  return {
    get(apiPath, params, config = {}) {
      return HTTP.get(apiPath, { params, ...config });
    },
    put(apiPath, data, config = {}) {
      return HTTP.put(apiPath, data, config);
    },
    post(apiPath, data, config = {}) {
      return HTTP.post(apiPath, data, config);
    },
    delete(apiPath, data, config = {}) {
      return HTTP.delete(apiPath, { data, ...config });
    }
  };
};

export default requestFactory();
